"use client";
import ImageAvatar from "@mui/material/Avatar";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import { cn } from "../../utils";

interface AvatarProps {
  src?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  className?: string;
  sx?: SxProps<Theme>;
}

export function Avatar({
  src,
  fullName,
  firstName,
  lastName,
  className,
  sx,
}: AvatarProps) {
  const defaultSx: SxProps<Theme> = (theme) => ({
    backgroundColor: theme.palette.info.main,
  });

  const mergedSx: SxProps<Theme> = sx
    ? ([
        defaultSx,
        ...(Array.isArray(sx) ? sx : [sx]),
      ] as unknown as SxProps<Theme>)
    : defaultSx;

  return (
    <>
      {Boolean(src) && (
        <ImageAvatar
          className={className}
          imgProps={{ crossOrigin: "anonymous" }}
          src={src as string}
        />
      )}
      {!src && (
        <Box
          className={cn(
            "flex h-10 w-10 items-center justify-center rounded-full",
            className
          )}
          sx={mergedSx}
        >
          <Typography color="white" variant="text_lg_sb">
            {Boolean(fullName) && fullName}
            {!fullName && firstName ? firstName[0] : null}
            {!fullName && lastName ? lastName[0] : null}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default Avatar;
